import { render, staticRenderFns } from "./AdminRegularScheduleList.vue?vue&type=template&id=b60db204&scoped=true&"
import script from "./AdminRegularScheduleList.vue?vue&type=script&lang=js&"
export * from "./AdminRegularScheduleList.vue?vue&type=script&lang=js&"
import style0 from "./AdminRegularScheduleList.vue?vue&type=style&index=0&id=b60db204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60db204",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VDialog,VIcon,VRow})
